<template>
  <v-row no-gutters class="flex-nowrap">
    <v-col cols="2" />
    <v-col v-for="region in regions" :key="region"
      ><h3>{{ region }}</h3></v-col
    >
  </v-row>

  <v-row no-gutters class="flex-nowrap">
    <v-col cols="2">Raise 5m</v-col>
    <v-col v-for="region in regions" :key="region">
      <v-sheet :color="allColors['raise5Min'][region]">{{ allPrices['raise5Min'][region] }} </v-sheet>
    </v-col>
  </v-row>
  <v-row no-gutters class="flex-nowrap">
    <v-col cols="2">Raise 60s</v-col>
    <v-col v-for="region in regions" :key="region">
      <v-sheet :color="allColors['raise60Sec'][region]">{{ allPrices['raise60Sec'][region] }} </v-sheet>
    </v-col>
  </v-row>
  <v-row no-gutters class="flex-nowrap">
    <v-col cols="2">Raise 6s</v-col>
    <v-col v-for="region in regions" :key="region">
      <v-sheet :color="allColors['raise6Sec'][region]">{{ allPrices['raise6Sec'][region] }} </v-sheet>
    </v-col>
  </v-row>
  <v-row no-gutters class="flex-nowrap">
    <v-col cols="2">Raise 1s</v-col>
    <v-col v-for="region in regions" :key="region">
      <v-sheet :color="allColors['raise1Sec'][region]">{{ allPrices['raise1Sec'][region] }} </v-sheet>
    </v-col>
  </v-row>
  <v-row no-gutters class="flex-nowrap">
    <v-col cols="2">Raise Reg</v-col>
    <v-col v-for="region in regions" :key="region">
      <v-sheet :color="allColors['raiseReg'][region]">{{ allPrices['raiseReg'][region] }}</v-sheet>
    </v-col>
  </v-row>

  <v-row no-gutters class="flex-nowrap" style="background: #eeeeee">
    <v-col cols="2" class="font-weight-bold">Energy</v-col>
    <v-col v-for="region in regions" :key="region">
      <v-sheet :color="allColors['energy'][region]" class="font-weight-bold">{{ allPrices['energy'][region] }} </v-sheet>
    </v-col>
  </v-row>

  <v-row no-gutters class="flex-nowrap">
    <v-col cols="2">Lower Reg</v-col>
    <v-col v-for="region in regions" :key="region">
      <v-sheet :color="allColors['lowerReg'][region]">{{ allPrices['lowerReg'][region] }}</v-sheet>
    </v-col>
  </v-row>
  <v-row no-gutters class="flex-nowrap">
    <v-col cols="2">Lower 1s</v-col>
    <v-col v-for="region in regions" :key="region">
      <v-sheet :color="allColors['lower1Sec'][region]">{{ allPrices['lower1Sec'][region] }} </v-sheet>
    </v-col>
  </v-row>
  <v-row no-gutters class="flex-nowrap">
    <v-col cols="2">Lower 6s</v-col>
    <v-col v-for="region in regions" :key="region">
      <v-sheet :color="allColors['lower6Sec'][region]">{{ allPrices['lower6Sec'][region] }} </v-sheet>
    </v-col>
  </v-row>
  <v-row no-gutters class="flex-nowrap">
    <v-col cols="2">Lower 60s</v-col>
    <v-col v-for="region in regions" :key="region">
      <v-sheet :color="allColors['lower60Sec'][region]">{{ allPrices['lower60Sec'][region] }} </v-sheet>
    </v-col>
  </v-row>
  <v-row no-gutters class="flex-nowrap">
    <v-col cols="2">Lower 5m</v-col>
    <v-col v-for="region in regions" :key="region">
      <v-sheet :color="allColors['lower5Min'][region]">{{ allPrices['lower5Min'][region] }} </v-sheet>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { RegionPrices, SnapshotDetail } from '@/repositories';
import HeatMap from '@/heatMaps/heatMap';

export default defineComponent({
  name: 'MobileTable',
  props: {
    current: SnapshotDetail
  },
  data() {
    return {
      regions: ['QLD1', 'NSW1', 'VIC1', 'SA1', 'TAS1'],
      markets: [
        //
        'raise5Min',
        'raise60Sec',
        'raise6Sec',
        'raise1Sec',
        'raiseReg',
        'energy',
        'lowerReg',
        'lower1Sec',
        'lower6Sec',
        'lower60Sec',
        'lower5Min'
      ]
    };
  },
  computed: {
    allPrices(): { [key: string]: { [key: string]: string } } {
      return this.markets.reduce(
        (o, key) => ({
          ...o,
          [key]: this.regionMarketPrices(key)
        }),
        {}
      );
    },
    allColors(): { [key: string]: { [key: string]: string } } {
      return this.markets.reduce(
        (o, key) => ({
          ...o,
          [key]: this.regionMarketColors(key)
        }),
        {}
      );
    }
  },
  methods: {
    formatPrice(price: number | undefined) {
      if (price === undefined) {
        return '--';
      }

      return `$${price.toFixed(2)}`;
    },
    regionMarketPrices(market: string) {
      const mkt = market as keyof RegionPrices;
      // ugh this got GROSS
      if (
        mkt == 'toJSON' ||
        mkt == 'init' ||
        mkt == 'suspended' ||
        mkt == 'energyFlags' ||
        mkt == 'raiseRegFlags' ||
        mkt == 'raise1SecFlags' ||
        mkt == 'raise6SecFlags' ||
        mkt == 'raise60SecFlags' ||
        mkt == 'raise5MinFlags' ||
        mkt == 'lowerRegFlags' ||
        mkt == 'lower1SecFlags' ||
        mkt == 'lower6SecFlags' ||
        mkt == 'lower60SecFlags' ||
        mkt == 'lower5MinFlags'
      ) {
        return 0;
      }
      return this.regions.reduce((o, region) => {
        return {
          ...o,
          [region]: this.formatPrice(this.current?.regions?.[region]?.prices?.[mkt])
        };
      }, {});
    },
    regionMarketColors(market: string) {
      const max = market === 'energy' ? 326 : 112;
      const mkt = market as keyof RegionPrices;
      if (
        mkt == 'toJSON' ||
        mkt == 'init' ||
        mkt == 'suspended' ||
        mkt == 'energyFlags' ||
        mkt == 'raiseRegFlags' ||
        mkt == 'raise1SecFlags' ||
        mkt == 'raise6SecFlags' ||
        mkt == 'raise60SecFlags' ||
        mkt == 'raise5MinFlags' ||
        mkt == 'lowerRegFlags' ||
        mkt == 'lower1SecFlags' ||
        mkt == 'lower6SecFlags' ||
        mkt == 'lower60SecFlags' ||
        mkt == 'lower5MinFlags'
      ) {
        return 0;
      }
      return this.regions.reduce(
        (o, region) => ({
          ...o,
          [region]: HeatMap.default //
            .getColor(this.current?.regions?.[region]?.prices?.[mkt] ?? 0, 0, max)
            .toRgba(0.25)
        }),
        {}
      );
    }
  }
});
</script>
